import styled from 'styled-components';
import { Button } from 'components/atoms/button';
import { Select as OzoneSelect } from 'components/atoms/select';
import {
  Caption01,
  ProductiveHeading06,
  ProductiveHeading07,
} from 'components/styles';

export const Wrapper = styled.div`
  display: flex;
  background: var(--coolest-gray-10);
  gap: var(--spacing-05);
  overflow: hidden;
  height: 100%;
  padding: var(--spacing-05) 0 0 var(--spacing-05);
`;

export const LeftSection = styled.div`
  width: 33rem;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  box-shadow: var(--shadow-02);
`;

export const RightSection = styled.div`
  width: calc(100vw - 32rem);
  height: 100%;
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
  gap: var(--spacing-05);
`;

export const HeaderAndSelectedIntervalsWrapper = styled.div`
  height: calc(100% - 3rem);
`;

export const LeftSectionHeaderWrapper = styled.div`
  height: 5rem;
  background: var(--coolest-gray-10);
  display: flex;
  align-items: center;
  gap: var(--spacing-03);
  padding: var(--spacing-05);
`;

export const SelectedIntervalsWrapper = styled.div`
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
  height: calc(100% - 5rem);
  background-color: var(--white-100);
`;

export const SelectOptionsWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: var(--spacing-02);
`;

export const LeftSectionFooter = styled.div`
  display: flex;
  align-items: center;
  gap: var(--spacing-02);
  padding: var(--spacing-05);
  border-top: 1px solid #e0e0e0;
  background-color: var(--white-100);
`;

export const CardWrapper = styled.div`
  display: flex;
  flex-direction: column;
  background-color: var(--white-100);
  box-shadow: var(--shadow-02);
`;

export const Select = styled(OzoneSelect)`
  .ozone-select__control {
    width: 12rem;
    border: none;
    background: transparent;
    outline: none !important;
    cursor: pointer;
  }

  .ozone-select__placeholder {
    color: var(--blue-60);
  }

  .ozone-select__indicators {
    display: none;
  }
`;

export const AtomSelect = styled(OzoneSelect)`
  width: 11rem;
  min-width: 11rem;
`;

export const Heading = styled.div`
  ${ProductiveHeading06};
`;

export const Caption = styled.div`
  ${Caption01};
  color: var(--gray-50);
`;

export const Header = styled.h1`
  ${ProductiveHeading07};
  font-weight: var(--font-weight-bold) !important;
  margin: var(--spacing-05);
`;

export const IntervalAtomWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-03);
  margin: var(--spacing-05);
  margin-bottom: var(--spacing-03);
`;

export const IntervalLabel = styled.div`
  color: var(--blue-60);
`;

export const IntervalAtomSelectWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 21rem;
  gap: var(--spacing-04);
`;

export const AddIntervalButton = styled(Button)`
  &:hover,
  &:active,
  &:focus {
    color: var(--blue-60) !important;
    text-decoration: none;
  }
`;

export const AndDiv = styled.div`
  color: var(--gray-50);
`;
